<div class="handle-labels">
  <span [style]="{ left: (100 / (max - min)) * (ngControl.value[0] - min) + '%' }">
    {{ ngControl.value[0] }}
  </span>
  @if (ngControl.value[0] !== ngControl.value[1]) {
    <span [style]="{ left: (100 / (max - min)) * (ngControl.value[1] - min) + '%' }">
      {{ ngControl.value[1] }}
    </span>
  }
</div>
<div class="interval-markers">
  @for (position of getIntervalArray(); track position) {
    <span [style]="{ left: (100 / getIntervalArray().length) * position + '%' }"> </span>
  }
  <span [style]="{ right: '0' }"></span>
</div>
<p-slider
  [formControl]="ngControl.control | abstractControlToFormControl"
  [min]="min"
  [max]="max"
  [step]="step"
  [range]="range"
  [animate]="true" />
